import React from 'react';
import styles from './DateRangeFilter.module.css';

/** yyyy-mm-dd in the browser's time zone. */
export const toInputDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const daysAgo = (days) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
};

export const DATE_PRESETS = [
  { key: 'today', label: 'Today', range: () => [new Date(), new Date()] },
  { key: 'yesterday', label: 'Yesterday', range: () => [daysAgo(1), daysAgo(1)] },
  { key: 'last_7_days', label: 'Last 7 days', range: () => [daysAgo(6), new Date()] },
  {
    key: 'this_month',
    label: 'This month',
    range: () => {
      const today = new Date();
      return [new Date(today.getFullYear(), today.getMonth(), 1), today];
    },
  },
  {
    key: 'last_month',
    label: 'Last month',
    range: () => {
      const today = new Date();
      return [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)];
    },
  },
];

/** { start, end } as yyyy-mm-dd for a preset key. */
export const presetRange = (key) => {
  const preset = DATE_PRESETS.find((item) => item.key === key) || DATE_PRESETS[0];
  const [start, end] = preset.range();
  return { start: toInputDate(start), end: toInputDate(end) };
};

/**
 * Quick ranges (today, yesterday, last 7 days, this month, last month) above a
 * from/to pair. `onChange({ start, end })` gets yyyy-mm-dd strings.
 */
const DateRangeFilter = ({ start, end, onChange, startLabel = 'From', endLabel = 'To' }) => {
  const activePreset = DATE_PRESETS.find((preset) => {
    const range = presetRange(preset.key);
    return range.start === start && range.end === end;
  })?.key;

  return (
    <div className={styles.dateRange}>
      <div className={styles.presets} role="group" aria-label="Quick date ranges">
        {DATE_PRESETS.map((preset) => (
          <button
            type="button"
            key={preset.key}
            className={`${styles.preset} ${activePreset === preset.key ? styles.presetActive : ''}`}
            aria-pressed={activePreset === preset.key}
            onClick={() => onChange(presetRange(preset.key))}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <div className={styles.inputs}>
        <label className={styles.field}>
          <span>{startLabel}</span>
          <input
            type="date"
            value={start || ''}
            max={end || undefined}
            onChange={(event) => onChange({ start: event.target.value, end })}
          />
        </label>
        <label className={styles.field}>
          <span>{endLabel}</span>
          <input
            type="date"
            value={end || ''}
            min={start || undefined}
            onChange={(event) => onChange({ start, end: event.target.value })}
          />
        </label>
      </div>
    </div>
  );
};

export default DateRangeFilter;
